<div class="whole-bg-green">
    <div class="row">
        <div class="col-lg-1 col-0"></div>
        <div class="col-lg-5 col-12">
            <h1>Thank You</h1>
            <p>Our team will contact you shortly to discuss the next steps</p>
            <h4>In the meantime, <br><span>Learn more about Worknigeria</span></h4>
            <button (click)="goToAboutUs()">Learn More <img src="../../../assets/images/black-arrow-right.webp"/></button>
        </div>
        <div class="col-lg-5 col-12 d-flex justify-content-center">
            <img src="../../../assets/images/thankyou-image.webp" />
        </div>
        <div class="col-lg-1 col-0"></div>
    </div>
</div>